import React from "react"
import _ from "lodash"

type IAtRest = {
  rowData: {
    // recoverypooldetail: {
    //   expenseItems: {
    //     lineItems: object[]
    //   }
    //   tenantContributionItems: {
    //     items: object[]
    //   }
    // }
  }
  field?: string
}

const InputTypeAtRest = (props: IAtRest) => {
  // let record = props.rowData
  // let displayValue = ""
  // if(record && record.recoverypooldetail) {
  //   let expenses = 0, contributions = 0, total = 0
  //   const { expenseItems, tenantContributionItems } = record.recoverypooldetail
  //   if(expenseItems && expenseItems.lineItems) expenses = expenseItems.lineItems.length
  //   if(tenantContributionItems && tenantContributionItems.items) contributions = tenantContributionItems.items.length
  //   total = expenses + contributions
  //   displayValue = `${expenses.toString()} ${expenses === 1 ? "Expense" : "Expenses"}, ${contributions.toString()} ${contributions === 1 ? "Tenant Contribution" : "Tenant Contributions"}`
  // }

  return <span>Detailed</span>
}

export default InputTypeAtRest
